import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

/**
 * SafeUrlPipe - Sanitizes URLs for use in iframes
 * 
 * Required by Angular's security model to bypass URL sanitization
 * for trusted YouTube embed URLs.
 * 
 * Usage: [src]="url | safeUrl"
 */
@Pipe({
  name: 'safeUrl',
  standalone: false
})
export class SafeUrlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(url: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}

